var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.70833 28.375C2.86042 28.375 2.12813 28.0795 1.51146 27.4885C0.920486 26.8719 0.625 26.1396 0.625 25.2917V3.70833C0.625 2.86042 0.920486 2.14097 1.51146 1.55C2.12813 0.933334 2.86042 0.625 3.70833 0.625H25.2917C26.1396 0.625 26.859 0.933334 27.45 1.55C28.0667 2.14097 28.375 2.86042 28.375 3.70833V25.2917C28.375 26.1396 28.0667 26.8719 27.45 27.4885C26.859 28.0795 26.1396 28.375 25.2917 28.375H3.70833ZM3.70833 25.2917H25.2917V3.70833H3.70833V25.2917ZM5.25 22.2083H23.75L17.9688 14.5L13.3438 20.6667L9.875 16.0417L5.25 22.2083ZM3.70833 25.2917V3.70833V25.2917Z",
    fill: "#1D1B20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionUpload);
export default __webpack_public_path__ + "static/media/question-upload.c1fdf30934264b1dbeadab7bfcbea8cc.svg";
export { ForwardRef as ReactComponent };